import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import Select from 'react-select';
import { getProfilescat,postUser,putUser,resourcesRoutes } from '../../../helpers/backend_helper';
import { getStorageUser } from '../../../helpers/api_helper';
import {Alert} from '../../../helpers/alerts/alertHelper';
import Validate from './Validate'
import ValidatePhone from './ValidatePhone';
import { PROFILES } from '../../../components/VerticalLayout/SidebarContent';

const AddUpdModal = ({modal,setModal,items, setItems, setUser,user}) => {
	const [selects, setSelects] = useState({rutas:[],profiles:[{id:0,name:''}]});
	const [ errors, setErrors ] = useState([]);
	const [ loading, setLoading ] = useState(false);

	const authUser = getStorageUser();
	const handleClose = () => {
		setModal({...modal,show:false,update:false});
    }

    const handlerOnChange = (value,name) => {
    	if(name=='profile' || name=='route'){
    		setUser({...user, [name=='profile' ? 'profile_id':'route_id']:value.id,[name]:value});
    	}else{
    		setUser({...user, [name]:value});
    	}
    }

    const save = async () => {
    	setErrors([])
    	const validate = Validate(user);
    	if(validate != undefined){
            setErrors(validate);
            setLoading(false)
            return;
        }
    	setLoading(true)
    	const response = await (modal.update ?  putUser(user):postUser(user))
    	responseAction(response);
    }

    const responseAction = (response) => {
    	if(response.status){
    		const newItem = response.user;
    		let array = [];
    		if(modal.update){
    			array = items.map(item => item.id !== newItem.id ? item : newItem);
    		}else{
    			array = [...items, newItem];
    			array.sort((a, b) => {
    				return a.id - b.id;
    			});
    		}
    		setItems(array);
			handleClose()
			setLoading(false)
    	}else{
    		setLoading(false)
    		setErrors(response.response.data.errors)
    	}
    }

    useEffect(() => {
    	const getSelects = async()=>{
    		let params={params:{select:true}}
    		const response = await getProfilescat();
    		if(authUser.profile_id==2){
    			const resp = await resourcesRoutes('get',params)
				setSelects({...selects,rutas:resp.data,profiles:response.profiles});
    		}else{
    			setSelects({...selects,profiles:response.profiles});
    		}
    	}
    	getSelects()
    }, [])

    return (
		<div>
	        <Modal isOpen={modal.show}>
				<ModalHeader className="bg-primary">{modal.update ? 'Editar ':'Agregar '}Usuario</ModalHeader>
				<ModalBody>
				<div className="row">
					<div className="col-sm-12">
					    <label className="form-label">Nombre:</label>
					    <input className="form-control" name="name" type="text" onChange={ e => handlerOnChange(e.target.value,'name') } value={user.name}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.name && errors.name[0]}</div>
					    }
					</div>
					<div className="col-sm-6">
					    <label className="form-label">Email:</label>
					    <input className="form-control"  name="email" type="text" onChange={ e => handlerOnChange(e.target.value, 'email') } value={user.email}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.email && errors.email[0]}</div>
					    }
					</div>
					
					{[PROFILES.Reseller, PROFILES.SuperAdmin].includes(authUser.profile_id) &&
					<div className="col-sm-6">
					    <label className="form-label">Ruta:</label>
					    <Select
							className="basic-single"
							classNamePrefix="select"
							isClearable={true}
							defaultValue={user.route}
							isSearchable={true}
							getOptionLabel={(option) => `${option.name}`}
							getOptionValue={(option) => `${option.id}`}
							name="color"
							options={selects.rutas}
							onChange={ e => handlerOnChange(e, 'route') }
						/>
					    {
					    	errors && <div className="form-text text-danger">{errors.route_id && errors.route_id[0]}</div>
					    }
					</div>
					}
					<div className="col-sm-6">
					    <label className="form-label">Perfil:</label>
					    <Select
							className="basic-single"
							classNamePrefix="select"
							isClearable={true}
							defaultValue={user.profile}
							isSearchable={true}
							getOptionLabel={(option) => `${option.name}`}
							getOptionValue={(option) => `${option.id}`}
							name="color"
							options={selects.profiles}
							onChange={ e => handlerOnChange(e, 'profile') }
						/>
					    {
					    	errors && <div className="form-text text-danger">{errors.profile_id && errors.profile_id[0]}</div>
					    }
					</div>
					<div className="col-sm-6">
					    <label className="form-label">Teléfono Celular:</label>
						<div className='input-group'>
					    	<input
								className="form-control" 
								name="phone"
								type="number"
								onChange={ e => {
									handlerOnChange(e.target.value, 'phone');

									setUser((prev) => ({
										...prev,
										phone_validated: 0,
									  }));
								}}
								value={user.phone ? user.phone : ''}
							/>
							<ValidatePhone
								user={user}
								setUser={setUser}
							/>
						</div>
					    {
					    	errors && <div className="form-text text-danger">{errors.phone && errors.phone[0]}</div>
					    }
					</div>
					<div className="col-sm-6">
					    <label className="form-label">Teléfono Local:</label>
					    <input className="form-control"  name="local_phone" type="number" onChange={ e => handlerOnChange(e.target.value, 'local_phone') } value={user.local_phone ?user.local_phone:''}/>
					    {
					    	errors && <div className="form-text text-danger">{errors.local_phone && errors.local_phone[0]}</div>
					    }
					</div>
					</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="primary" onClick={save} disabled={loading}>
						{loading && <Spinner size="sm"></Spinner> } <i className='fa fa-save'></i> Guardar
					</Button>{' '}
					<Button color="secondary" onClick={handleClose}><i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
	        </Modal>
		</div>
	);
}

export default AddUpdModal;